import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { PlaceDto, PlaceService } from 'src/app/proxy/places';
import { AppConsts } from '../../AppConsts';

@Component({
  selector: 'app-place-selector',
  standalone: false,
  templateUrl: './place-selector.component.html',
})
export class PlaceSelectorComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() placeIdSelected: number;
  @Input() isDisabled = false;

  @Output() changeSelectedPlace = new EventEmitter<PlaceDto>();
  places: PlaceDto[];
  selectedPlace: PlaceDto;

  constructor(
    injector: Injector,
    private readonly _placeService: PlaceService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadPlaces();
    this.onSelected();
  }

  async loadPlaces(): Promise<void> {
    try {
      this.showLoading();

      const result = await firstValueFrom(this._placeService.getAllByInput({
        maxResultCount: AppConsts.MaxPageSize,
        skipCount: 0
      }));

      this.places = result.items;
    } finally {
      this.hideLoading();
    }
  }

  onSelected(): void {
    this.changeSelectedPlace.emit(this.selectedPlace);
  }

  async setSelectedPlaceById(placeId: number): Promise<void> {
    if (!placeId) {
      return;
    }

    this.placeIdSelected = placeId;

    if (this.isNullOrUndefined(this.places)) {
      await this.loadPlaces();
    }
    
    this.setSelectedPlace();
  }

  private setSelectedPlace(): void {
    if (this.places?.length && !this.isNullOrUndefined(this.placeIdSelected)) {
      this.selectedPlace = this.places.find(x => x.id === this.placeIdSelected);
    }
    
    this.onSelected();
  }
}
